module.exports = __webpack_public_path__ + "static/media/sainte-arche.047a9336.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sainte-arche.jpg
// module id = 52
// module chunks = 1